import React, { useRef } from 'react'
import styles from './SkillCard.module.css'
import IconComponent from '../../IconComponent/IconComponent'
import { FaPencilAlt } from 'react-icons/fa'
import { IconType } from 'react-icons'

export type SkillCardProps = {
    title: string;
    text: string;
    icon: IconType;
    image: string;
    desc: string;
}

const SkillCard = (props: SkillCardProps) => {

    const overlayRef = useRef<HTMLDivElement>(null);
    const isMobile = window.innerWidth <= 768;

    const handleMouseMove = (e: React.MouseEvent) => {
        const overlay = overlayRef.current;
        if (!overlay) return;
    
        const rect = overlay.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;
    
        overlay.style.setProperty('--mouse-x', `${x}px`);
        overlay.style.setProperty('--mouse-y', `${y}px`);
      };

    return (
        <div className={styles.card} style={{ backgroundImage: `url(${props.image})` }}>
            <div 
                className={styles.skill_overlay}
                ref={overlayRef}
                onMouseMove={!isMobile ? handleMouseMove : undefined}
            >
                <div className={styles.icon}><IconComponent icon={props.icon} size={25} /></div>
                <div className={styles.skill_title}>{props.title}</div>
                <div className={styles.skill_text}>{props.text}</div>
                <div className={styles.skill_desc}>{props.desc}</div>
            </div>
        </div>
    )
}

export default SkillCard
